// extracted by mini-css-extract-plugin
export default {"emptyImageContainer":"kHq_Kn15bc47ILCv_vdG"};